var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"estimate-export-wrapper"},[_c('div',{staticClass:"pdf-viewer"},[_c('embed',{ref:"",attrs:{"src":_vm.pdfViewerUrl,"type":"application/pdf","frameborder":"0","width":"100%","height":"100%"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }